import React from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { isAdminSupervisor, isSupervisor } from '../Authetication'



export default function SupervisorRoutes() {


  let auth = {"token": isAdminSupervisor()}

  

  return (
   auth.token ? <Outlet/> : <Navigate to="/dashboard"/>
  )
}
